import { InvoiceStatus } from "@gymflow/types";

import { DotBadgeProps } from "../../atoms/DotBadge";

const INVOICE_STATUS = {
  PAID: "PAID",
  PAST_DUE: "PAST_DUE",
  SCHEDULED: "SCHEDULED",
  AWAITING_AUTHORIZATION: "AWAITING_AUTHORIZATION",
}

const StatusToColor = {
  AWAITING_AUTHORIZATION: "warning",
  PAID: "success",
  PAST_DUE: "error",
  DISPUTED: "error",
  PROCESSING: "gray",
  RE_SCHEDULE: "warning",
  REFUNDED: "gray",
  SCHEDULED: "secondary",
  VOID: "error",
  WRITTEN_OFF: "gray",
} satisfies {
  [key in InvoiceStatus]: DotBadgeProps["intent"];
};

export {INVOICE_STATUS, StatusToColor}